import React, { cloneElement } from 'react';
import classnames from 'classnames';
import TooltipIcon from 'Components/ToolipIcon';
import './styles.scss';

function modifyChild({ children, validationMessages, highlightChildren }, otherProps) {
  const className = classnames(
    children.props ? children.props.className : '',
    'swa-form-group__input', { 'is-invalid': !!validationMessages && !!highlightChildren });
  return cloneElement(children, {
    ...children.props,
    ...otherProps,
    className,
    // invalid: !!validationMessages,
  });
}

const formGroup = (
  { label, isRequired, children, validationMessages, className, tooltip, highlightChildren, subLabel }
) => {
  return (
    <div className={classnames('form-group', 'swa-form-group', className)}>
      {!!label && (
        <div className="label-wrapper">
          <label className="font-weight-bold">
            <span className={classnames({ 'required': !!isRequired })}>{label}</span>
            {!!tooltip && (<TooltipIcon title={tooltip} />)}
          </label>
          {!!subLabel && (
            <p className="label-wrapper__sub-label text-secondary">{subLabel}</p>
          )}
        </div>
      )}
      {!!children.map && children.map((child, index) => modifyChild(
        { children: child, validationMessages },
        { key: index },
      ))}
      {!children.map && modifyChild({ children, validationMessages, highlightChildren })}
      {!!validationMessages && (
        <div className="swa-form-group__validation-message">
          {validationMessages.join('; ')}
        </div>
      )}
    </div>
  );
}

formGroup.defaultProps = {
  highlightChildren: true,
}

export default formGroup;
